import React from 'react';
import './styles.scss';

export const Hero = ({ backgroundImage, title }) => {
  return (
    <div className="hero container-fluid container-fluid--custom p-0">
      <div className="hero__image" style={{ backgroundImage: `url(${backgroundImage})` }}>
        <h1 className="hero__title ms-6 fw-bold">{title}</h1>
      </div>
    </div>
  );
};
